export const replaceStringVars = (string, vars) => {
  return Object.keys(vars).reduce((acc, key) => {
    const re = new RegExp(`{{${key}}}`, 'g');
    return acc.replace(re, vars[key]);
  }, string);
};
